import BaseTagger from './BaseTagger';
import OnlineSales2 from "./contexts/OnlineSales2";
import VehicleContextAdder from './contexts/adders/VehicleContextAdder.js';

export default class ObjectDataTagger extends BaseTagger {
  /**
   * Tagging a structured event.
   * {@link https://docs.snowplowanalytics.com/docs/collecting-data/collecting-from-own-applications/javascript-tracker/tracking-specific-events/#Tracking_custom_structured_events|Documentation}
   * @param {object} data
   * @param {string} data.category
   * @param {string} data.action
   * @param {string|null} data.label
   * @param {string|null} data.property
   * @param {string|null} data.value
   */
  trackStructuredEvent(data) {
    super.trackStructuredEvent(data.category, data.action, data.label, data.property, data.value);
  }

  /**
   * Adding Online Sales Context
   * @param {object} data
   * @param {string} data.step - current OVS step
   * @param {string|null} data.previousStep - previous OVS step
   * @param {string} data.entryPoint - current OVS journey entry point
   * @param {string|null} data.paymentMethod
   * @param {array<string>|null} data.extrasList - extras included in OVS
   * @param {integer|null} data.extrasValue - included extras in total
   * @param {string|null} data.deliveryMethod - selected delivery method
   * @param {integer|null} data.deliveryValue - delivery value
   * @param {string|null} data.provider - payment provider
   * @param {string|null} data.option
   * @param {boolean|null} data.seen - was part exchange seen
   * @param {boolean|null} data.usedForQuote - was part exchange set in quote
   */
  addOnlineSalesContext(data) {
    const context = new OnlineSales2(data.step, data.previousStep, data.entryPoint, data.paymentMethod, data.extrasList, data.extrasValue, data.deliveryMethod, data.deliveryValue, data.provider, data.option, data.seen, data.usedForQuote);
    this.snowplow.globalContexts.update(context);
  }

  addDealerContext(data) {
    throw new Error('Method not implemented yet');
  }

  /**
   * Adding Vehicle Context - fill fields if they are available.
   * An optional method for projects working without Auto v10
   *
   * @param {object} data
   * @param {integer|string} data.id
   * @param {'car'|'van'|'bike'} data.type
   * @param {string} data.manufacturer
   * @param {string} data.model
   * @param {string} data.variant
   * @param {boolean} data.franchise_approved
   * @param {string} data.registration_date - format: YYYY-MM-DD
   * @param {number|string} data.price
   * @param {string} data.colour
   * @param {string} data.body_style
   * @param {string} data.fuel_type
   * @param {string} data.transmission
   * @param {number|string} data.engine_size
   * @param {number|string} data.combined_mpg
   * @param {string} data.efficiency_unit
   * @param {string} data.tax_band
   * @param {array<string>} data.equipment
   * @param {string} data.group_hash
   * @param {string} data.franchise_hash
   * @param {string} data.location_hash
   * @param {string} data.currency
   * @param {string} data.vehicle_guid
   */
  addVehicleContext(data) {
    VehicleContextAdder.add(data, this.snowplow);
  }
}
